import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
import utils from 'src/utils';
export var AdvancedPlannerActions;
(function (AdvancedPlannerActions) {
    AdvancedPlannerActions["GET_ADVANCED_PLANNER_REQUEST"] = "GET_ADVANCED_PLANNER_REQUEST";
    AdvancedPlannerActions["GET_ADVANCED_PLANNER_SUCCESS"] = "GET_ADVANCED_PLANNER_SUCCESS";
    AdvancedPlannerActions["GET_ADVANCED_PLANNER_FAIL"] = "GET_ADVANCED_PLANNER_FAIL";
    AdvancedPlannerActions["GET_RAW_EVENTS_REQUEST"] = "GET_RAW_EVENTS_REQUEST";
    AdvancedPlannerActions["GET_RAW_EVENTS_SUCCESS"] = "GET_RAW_EVENTS_SUCCESS";
    AdvancedPlannerActions["GET_RAW_EVENTS_FAIL"] = "GET_RAW_EVENTS_FAIL";
    AdvancedPlannerActions["GET_EVENT_LUNCHES_REQUEST"] = "GET_EVENT_LUNCHES_REQUEST";
    AdvancedPlannerActions["GET_EVENT_LUNCHES_SUCCESS"] = "GET_EVENT_LUNCHES_SUCCESS";
    AdvancedPlannerActions["GET_EVENT_LUNCHES_FAIL"] = "GET_EVENT_LUNCHES_FAIL";
    AdvancedPlannerActions["UPDATE_EVENT_LUNCH_SUCCESS"] = "UPDATE_EVENT_LUNCH_SUCCESS";
    AdvancedPlannerActions["DELETE_EVENT_LUNCHES_SUCCESS"] = "DELETE_EVENT_LUNCHES_SUCCESS";
})(AdvancedPlannerActions || (AdvancedPlannerActions = {}));
function getAdvancedPlannerRequest() {
    return { type: AdvancedPlannerActions.GET_ADVANCED_PLANNER_REQUEST };
}
function getAdvancedPlannerSuccess(payload) {
    return { type: AdvancedPlannerActions.GET_ADVANCED_PLANNER_SUCCESS, payload };
}
function getAdvancedPlannerFail() {
    return { type: AdvancedPlannerActions.GET_ADVANCED_PLANNER_FAIL };
}
function getRawEventsRequest() {
    return { type: AdvancedPlannerActions.GET_RAW_EVENTS_REQUEST };
}
function getRawEventsSuccess(payload) {
    return { type: AdvancedPlannerActions.GET_RAW_EVENTS_SUCCESS, payload };
}
function getRawEventsFail() {
    return { type: AdvancedPlannerActions.GET_RAW_EVENTS_FAIL };
}
function getEventLunchesRequest() {
    return { type: AdvancedPlannerActions.GET_EVENT_LUNCHES_REQUEST };
}
function getEventLunchesSuccess(payload) {
    return { type: AdvancedPlannerActions.GET_EVENT_LUNCHES_SUCCESS, payload };
}
function getEventLunchesFail() {
    return { type: AdvancedPlannerActions.GET_EVENT_LUNCHES_FAIL };
}
function updateEventLunchSuccess(payload) {
    return { type: AdvancedPlannerActions.UPDATE_EVENT_LUNCH_SUCCESS, payload };
}
function deleteEventLunchesSuccess(payload) {
    return { type: AdvancedPlannerActions.DELETE_EVENT_LUNCHES_SUCCESS, payload };
}
export function getAdvancedPlanner(params) {
    return (dispatch) => {
        dispatch(getAdvancedPlannerRequest());
        return Promise.all([
            wtsApi.events.eventsList(params),
            wtsApi.workDays.workDaysList({ period: params.period }),
            wtsApi.v2.plannerSearchCreate({
                DepartmentIds: params.departmentIds?.length ? params.departmentIds.map(Number) : null,
                ProjectIds: params.projectIds?.length ? params.projectIds.map(Number) : null,
                From: params.period?.split(',')[0],
                To: utils.periods.endDateInclusiveToExclusive(params.period?.split(',')[1]),
                // @ts-ignore
                UserIds: [null]
            })
        ])
            .then(async ([eventsResponse, workDaysResponse, rawEventsResponse]) => {
            const eventsData = eventsResponse.data;
            const workDaysData = workDaysResponse.data;
            const rawEventsData = rawEventsResponse.data;
            dispatch(getAdvancedPlannerSuccess({
                eventsData: eventsData.Data || [],
                workDaysData: workDaysData.Data,
                rawEventsData: rawEventsData.Data || []
            }));
            if (!eventsData?.Data?.length && !rawEventsData?.Data?.length) {
                toastr.warning(I18n.t('NoDataAvailable'), '');
            }
        })
            .catch((error) => {
            console.error(error);
            dispatch(getAdvancedPlannerFail());
            toastrError(error);
        });
    };
}
// Get raw events action
export function getRawEvents(params) {
    return (dispatch) => {
        dispatch(getRawEventsRequest());
        return wtsApi.v2.plannerSearchCreate(params)
            .then((response) => {
            dispatch(getRawEventsSuccess(response.data.Data));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getRawEventsFail());
            toastrError(error);
        });
    };
}
// Add jobs action
export function addJobs(params) {
    return wtsApi.v2.plannerAddJobsCreate(params)
        .then((response) => {
        toastr.success(I18n.t('JobsAddedSuccessfully'), '');
        return response.data;
    })
        .catch((error) => {
        console.error(error);
        toastrError(error);
        throw error;
    });
}
// Update jobs action
export function updateJobs(params) {
    return wtsApi.v2.plannerUpdateJobsUpdate(params)
        .then((response) => {
        toastr.success(I18n.t('JobsUpdatedSuccessfully'), '');
        return response.data;
    })
        .catch((error) => {
        console.error(error);
        toastrError(error);
        throw error;
    });
}
// Add absences action
export function addAbsences(params) {
    return wtsApi.v2.plannerAddAbsencesCreate(params)
        .then((response) => {
        toastr.success(I18n.t('AbsencesAddedSuccessfully'), '');
        return response.data;
    })
        .catch((error) => {
        console.error(error);
        toastrError(error);
        throw error;
    });
}
// Update absences action
export function updateAbsences(params) {
    return wtsApi.v2.plannerUpdateAbsencesUpdate(params)
        .then((response) => {
        toastr.success(I18n.t('AbsencesUpdatedSuccessfully'), '');
        return response.data;
    })
        .catch((error) => {
        console.error(error);
        toastrError(error);
        throw error;
    });
}
// Delete events action
export function deleteEvents(params) {
    return (dispatch, getState) => {
        const state = getState();
        const eventLunches = state.advancedPlanner.eventLunches;
        // Extract event IDs from params
        const eventIds = params.ids?.split(',').map(Number) || [];
        // Find lunch policies that need to be deleted
        const lunchesToDelete = eventIds
            .map((eventId) => eventLunches[eventId])
            .filter((lunch) => lunch && lunch.Id)
            .map((lunch) => lunch.Id);
        // Delete lunch policies first if any exist
        const deleteLunchPoliciesPromise = lunchesToDelete.length > 0
            ? Promise.all(lunchesToDelete.map((lunchId) => wtsApi.v2.lunchPolicyDeleteDelete({ Id: lunchId })))
            : Promise.resolve([]);
        return deleteLunchPoliciesPromise
            .then(() => {
            // Delete the events
            return wtsApi.events.eventsDelete(params);
        })
            .then(() => {
            // Update state to remove deleted lunch policies
            if (eventIds.length > 0) {
                dispatch(deleteEventLunchesSuccess(eventIds));
            }
            toastr.success(I18n.t('EventsDeletedSuccessfully'), '');
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            throw error;
        });
    };
}
// Get event lunches action
export function getEventLunches(eventIds) {
    return (dispatch) => {
        if (!eventIds.length) {
            dispatch(getEventLunchesSuccess({}));
            return Promise.resolve();
        }
        dispatch(getEventLunchesRequest());
        return wtsApi.v2.lunchPolicySearchCreate({
            PageSize: -1,
            EventIds: eventIds,
            ShiftIds: null,
            DepartmentIds: null,
            Ids: null
        })
            .then((response) => {
            const lunchesMap = {};
            if (response.data?.Data) {
                response.data.Data.forEach((lunch) => {
                    if (lunch.EventId) {
                        lunchesMap[lunch.EventId] = lunch;
                    }
                });
            }
            dispatch(getEventLunchesSuccess(lunchesMap));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getEventLunchesFail());
            toastrError(error);
        });
    };
}
// only EventId based
export function createUpdateEventLunch(request) {
    return (dispatch) => {
        return wtsApi.v2.lunchPolicyCreateUpdateCreate(request)
            .then(({ data }) => {
            if (data.Data && request.EventId) {
                dispatch(updateEventLunchSuccess({
                    eventId: request.EventId,
                    lunch: data.Data
                }));
            }
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            throw error;
        });
    };
}
export function getFlexibleLunchLenght(params) {
    return wtsApi.v2.lunchPolicyFlexibleLunchLengthList(params)
        .then((response) => {
        return response.data.Data?.Length || null;
    });
}
